"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTheme = void 0;
const styles_1 = require("@mui/material/styles");
const Tooltip_1 = require("@mui/material/Tooltip");
const fonts_1 = require("./fonts");
const colours_1 = require("./colours");
const cssOverrides = {
    components: {
        MuiCssBaseline: {
            styleOverrides: `
              ${fonts_1.effraRegular}
              ${fonts_1.effraMedium}
              ${fonts_1.effraBold}
              ${fonts_1.effraHeavy}
            `
        },
        MuiTableRow: {
            styleOverrides: {
                head: {
                    border: `1px solid ${colours_1.colours.storm}`
                }
            }
        },
        MuiTableCell: {
            styleOverrides: {
                head: {
                    color: "inherit",
                    padding: "16px",
                    fontWeight: "bold"
                },
                body: {
                    padding: "1rem 16px 0.67rem",
                    verticalAlign: "top",
                    border: 0
                }
            }
        },
        MuiTooltip: {
            styleOverrides: {
                popper: {
                    zIndex: 9,
                    [`.${Tooltip_1.tooltipClasses.tooltipPlacementBottom}`]: {
                        margin: 0
                    }
                }
            }
        },
        MuiTypography: {
            styleOverrides: {
                h3: {
                    "::after": {
                        marginTop: "0.75rem"
                    }
                },
                h4: {
                    "::after": {
                        marginTop: "0.5rem"
                    }
                }
            }
        }
    }
};
const defaultTheme = {
    breakpoints: {
        values: {
            xs: 0,
            sm: 600,
            md: 720,
            lg: 840,
            xl: 1440
        }
    },
    colours: {
        ...colours_1.colours,
        accent300: colours_1.colours.cyan400,
        accent: colours_1.colours.cyan400,
        inter: colours_1.colours.cyan500,
        interDark: colours_1.colours.cyan500,
        focus: colours_1.colours.cyan600,
        focusDark: colours_1.colours.cyan600,
        // Secondary(action cards colors)
        secondary1: colours_1.colours.cyan700,
        secondary2: colours_1.colours.slate,
        secondary3: colours_1.colours.blue800,
        secondary4: colours_1.colours.charcoal
    },
    palette: {
        primary: {
            // light: will be calculated from palette.primary.main,
            main: colours_1.colours.cyan500,
            dark: colours_1.colours.cyan600
            // contrastText: will be calculated to contrast with
            // palette.primary.main
        },
        secondary: {
            light: "#0066ff",
            main: "#0044ff",
            // dark: will be calculated from palette.secondary.main,
            contrastText: "#ffcc00"
        },
        error: {
            main: colours_1.colours.error400,
            light: colours_1.colours.error50,
            dark: colours_1.colours.error400
        },
        // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold: 3,
        // Used by the functions below to shift a color's luminance
        // by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset: 0.2,
        text: {
            primary: colours_1.colours.charcoal
        }
    },
    typography: {
        fontFamily: "Effra Regular",
        h1: {
            fontFamily: "Effra Heavy",
            fontSize: "2.125rem",
            letterSpacing: "-0.2px",
            lineHeight: 1.2
        },
        h2: {
            fontFamily: "Effra Heavy",
            fontSize: "1.75rem",
            letterSpacing: "-0.2px",
            lineHeight: 1.2
        },
        h3: {
            fontFamily: "Effra Bold",
            fontSize: "1.5rem",
            lineHeight: 1.2
        },
        h4: {
            fontFamily: "Effra Bold",
            fontSize: "1.35rem",
            lineHeight: 1.2
        },
        h5: {
            fontFamily: "Effra Medium",
            fontSize: "1.25rem",
            lineHeight: 1.2
        },
        h6: {
            fontFamily: "Effra Medium",
            fontSize: "1.125rem",
            lineHeight: 1.2
        },
        body1: {
            fontSize: "1rem",
            lineHeight: 1.4
        },
        body2: {
            fontSize: "1.125rem",
            lineHeight: 1.4
        },
        button: {
            textTransform: "none"
        }
    },
    ...cssOverrides
};
const getTheme = (modifyTheme = (t) => t) => {
    return (0, styles_1.createTheme)(modifyTheme(defaultTheme));
};
exports.getTheme = getTheme;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGhlbWUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvdGhlbWUtcHJvdmlkZXIvdGhlbWUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsaURBQTBEO0FBQzFELG1EQUF1RDtBQUN2RCxtQ0FBMkU7QUFDM0UsdUNBQW9DO0FBR3BDLE1BQU0sWUFBWSxHQUFHO0lBQ25CLFVBQVUsRUFBRTtRQUNWLGNBQWMsRUFBRTtZQUNkLGNBQWMsRUFBRTtnQkFDTixvQkFBWTtnQkFDWixtQkFBVztnQkFDWCxpQkFBUztnQkFDVCxrQkFBVTthQUNiO1NBQ1I7UUFDRCxXQUFXLEVBQUU7WUFDWCxjQUFjLEVBQUU7Z0JBQ2QsSUFBSSxFQUFFO29CQUNKLE1BQU0sRUFBRSxhQUFhLGlCQUFPLENBQUMsS0FBSyxFQUFFO2lCQUNyQzthQUNGO1NBQ0Y7UUFDRCxZQUFZLEVBQUU7WUFDWixjQUFjLEVBQUU7Z0JBQ2QsSUFBSSxFQUFFO29CQUNKLEtBQUssRUFBRSxTQUFTO29CQUNoQixPQUFPLEVBQUUsTUFBTTtvQkFDZixVQUFVLEVBQUUsTUFBTTtpQkFDbkI7Z0JBQ0QsSUFBSSxFQUFFO29CQUNKLE9BQU8sRUFBRSxtQkFBbUI7b0JBQzVCLGFBQWEsRUFBRSxLQUFLO29CQUNwQixNQUFNLEVBQUUsQ0FBQztpQkFDVjthQUNGO1NBQ0Y7UUFDRCxVQUFVLEVBQUU7WUFDVixjQUFjLEVBQUU7Z0JBQ2QsTUFBTSxFQUFFO29CQUNOLE1BQU0sRUFBRSxDQUFDO29CQUNULENBQUMsSUFBSSx3QkFBYyxDQUFDLHNCQUFzQixFQUFFLENBQUMsRUFBRTt3QkFDN0MsTUFBTSxFQUFFLENBQUM7cUJBQ1Y7aUJBQ0Y7YUFDRjtTQUNGO1FBQ0QsYUFBYSxFQUFFO1lBQ2IsY0FBYyxFQUFFO2dCQUNkLEVBQUUsRUFBRTtvQkFDRixTQUFTLEVBQUU7d0JBQ1QsU0FBUyxFQUFFLFNBQVM7cUJBQ3JCO2lCQUNGO2dCQUNELEVBQUUsRUFBRTtvQkFDRixTQUFTLEVBQUU7d0JBQ1QsU0FBUyxFQUFFLFFBQVE7cUJBQ3BCO2lCQUNGO2FBQ0Y7U0FDRjtLQUNGO0NBQ0YsQ0FBQztBQUVGLE1BQU0sWUFBWSxHQUFpQjtJQUNqQyxXQUFXLEVBQUU7UUFDWCxNQUFNLEVBQUU7WUFDTixFQUFFLEVBQUUsQ0FBQztZQUNMLEVBQUUsRUFBRSxHQUFHO1lBQ1AsRUFBRSxFQUFFLEdBQUc7WUFDUCxFQUFFLEVBQUUsR0FBRztZQUNQLEVBQUUsRUFBRSxJQUFJO1NBQ1Q7S0FDRjtJQUNELE9BQU8sRUFBRTtRQUNQLEdBQUcsaUJBQU87UUFDVixTQUFTLEVBQUUsaUJBQU8sQ0FBQyxPQUFPO1FBQzFCLE1BQU0sRUFBRSxpQkFBTyxDQUFDLE9BQU87UUFDdkIsS0FBSyxFQUFFLGlCQUFPLENBQUMsT0FBTztRQUN0QixTQUFTLEVBQUUsaUJBQU8sQ0FBQyxPQUFPO1FBQzFCLEtBQUssRUFBRSxpQkFBTyxDQUFDLE9BQU87UUFDdEIsU0FBUyxFQUFFLGlCQUFPLENBQUMsT0FBTztRQUUxQixpQ0FBaUM7UUFDakMsVUFBVSxFQUFFLGlCQUFPLENBQUMsT0FBTztRQUMzQixVQUFVLEVBQUUsaUJBQU8sQ0FBQyxLQUFLO1FBQ3pCLFVBQVUsRUFBRSxpQkFBTyxDQUFDLE9BQU87UUFDM0IsVUFBVSxFQUFFLGlCQUFPLENBQUMsUUFBUTtLQUM3QjtJQUNELE9BQU8sRUFBRTtRQUNQLE9BQU8sRUFBRTtZQUNQLHVEQUF1RDtZQUN2RCxJQUFJLEVBQUUsaUJBQU8sQ0FBQyxPQUFPO1lBQ3JCLElBQUksRUFBRSxpQkFBTyxDQUFDLE9BQU87WUFDckIsb0RBQW9EO1lBQ3BELHVCQUF1QjtTQUN4QjtRQUNELFNBQVMsRUFBRTtZQUNULEtBQUssRUFBRSxTQUFTO1lBQ2hCLElBQUksRUFBRSxTQUFTO1lBQ2Ysd0RBQXdEO1lBQ3hELFlBQVksRUFBRSxTQUFTO1NBQ3hCO1FBQ0QsS0FBSyxFQUFFO1lBQ0wsSUFBSSxFQUFFLGlCQUFPLENBQUMsUUFBUTtZQUN0QixLQUFLLEVBQUUsaUJBQU8sQ0FBQyxPQUFPO1lBQ3RCLElBQUksRUFBRSxpQkFBTyxDQUFDLFFBQVE7U0FDdkI7UUFDRCwrREFBK0Q7UUFDL0QsK0JBQStCO1FBQy9CLGlCQUFpQixFQUFFLENBQUM7UUFDcEIsMkRBQTJEO1FBQzNELG1CQUFtQjtRQUNuQix3Q0FBd0M7UUFDeEMsa0RBQWtEO1FBQ2xELFdBQVcsRUFBRSxHQUFHO1FBQ2hCLElBQUksRUFBRTtZQUNKLE9BQU8sRUFBRSxpQkFBTyxDQUFDLFFBQVE7U0FDMUI7S0FDRjtJQUNELFVBQVUsRUFBRTtRQUNWLFVBQVUsRUFBRSxlQUFlO1FBQzNCLEVBQUUsRUFBRTtZQUNGLFVBQVUsRUFBRSxhQUFhO1lBQ3pCLFFBQVEsRUFBRSxVQUFVO1lBQ3BCLGFBQWEsRUFBRSxRQUFRO1lBQ3ZCLFVBQVUsRUFBRSxHQUFHO1NBQ2hCO1FBQ0QsRUFBRSxFQUFFO1lBQ0YsVUFBVSxFQUFFLGFBQWE7WUFDekIsUUFBUSxFQUFFLFNBQVM7WUFDbkIsYUFBYSxFQUFFLFFBQVE7WUFDdkIsVUFBVSxFQUFFLEdBQUc7U0FDaEI7UUFDRCxFQUFFLEVBQUU7WUFDRixVQUFVLEVBQUUsWUFBWTtZQUN4QixRQUFRLEVBQUUsUUFBUTtZQUNsQixVQUFVLEVBQUUsR0FBRztTQUNoQjtRQUNELEVBQUUsRUFBRTtZQUNGLFVBQVUsRUFBRSxZQUFZO1lBQ3hCLFFBQVEsRUFBRSxTQUFTO1lBQ25CLFVBQVUsRUFBRSxHQUFHO1NBQ2hCO1FBQ0QsRUFBRSxFQUFFO1lBQ0YsVUFBVSxFQUFFLGNBQWM7WUFDMUIsUUFBUSxFQUFFLFNBQVM7WUFDbkIsVUFBVSxFQUFFLEdBQUc7U0FDaEI7UUFDRCxFQUFFLEVBQUU7WUFDRixVQUFVLEVBQUUsY0FBYztZQUMxQixRQUFRLEVBQUUsVUFBVTtZQUNwQixVQUFVLEVBQUUsR0FBRztTQUNoQjtRQUNELEtBQUssRUFBRTtZQUNMLFFBQVEsRUFBRSxNQUFNO1lBQ2hCLFVBQVUsRUFBRSxHQUFHO1NBQ2hCO1FBQ0QsS0FBSyxFQUFFO1lBQ0wsUUFBUSxFQUFFLFVBQVU7WUFDcEIsVUFBVSxFQUFFLEdBQUc7U0FDaEI7UUFDRCxNQUFNLEVBQUU7WUFDTixhQUFhLEVBQUUsTUFBTTtTQUN0QjtLQUNGO0lBQ0QsR0FBRyxZQUFZO0NBQ2hCLENBQUM7QUFFSyxNQUFNLFFBQVEsR0FBRyxDQUN0QixjQUFxRCxDQUFDLENBQUMsRUFBRSxFQUFFLENBQUMsQ0FBQyxFQUN0RCxFQUFFO0lBQ1QsT0FBTyxJQUFBLG9CQUFXLEVBQUMsV0FBVyxDQUFDLFlBQVksQ0FBQyxDQUFDLENBQUM7QUFDaEQsQ0FBQyxDQUFDO0FBSlcsUUFBQSxRQUFRLFlBSW5CIn0=